import React from 'react';
import { CTAButton } from '../CTAButton';
import { Countdown } from '../Countdown';
import { finalQuestions } from '../../data/content';
export function FinalCTA() {
  return <section className="w-full bg-navy-700 px-4 py-16 sm:px-6 sm:py-20" data-id="element-176" data-mp="3mts3gligb187">
      <div className="mx-auto max-w-2xl" data-id="element-177" data-mp="3mrnwtvt63o48">
        <h2 className="text-center font-display text-3xl font-bold leading-tight text-white sm:text-4xl" data-id="element-178" data-mp="3rsbqkp8s6j25">
          Your next complex DVO case doesn’t have to start with a blank page.
        </h2>

        <div className="mt-6 space-y-3 text-center text-[15px] leading-relaxed text-white/75" data-id="element-179" data-mp="3hv70iebte3g2">
          <p data-id="element-180" data-mp="33vfo2i0y4v46">You don’t need another folder full of scattered information.</p>
          <p data-id="element-181" data-mp="38tzdwtinur1t">
            You need a system that helps you organize what you already know into a repeatable
            workflow.
          </p>
        </div>

        <ul className="mt-8 space-y-2" data-id="element-182" data-mp="1242mo2y6t5cv">
          {finalQuestions.map(q => <li key={q} className="rounded-xl bg-white/[0.07] px-4 py-3 text-center text-[12.5px] font-bold uppercase tracking-[0.06em] text-white/85 ring-1 ring-white/10" data-id="element-183" data-mp="171kzi4fbs4q5">
              {q}
            </li>)}
        </ul>

        <p className="mt-7 text-center text-[15px] leading-relaxed text-white/75" data-id="element-184" data-mp="z0p40abey43z">
          That’s what Dr. Karito created the{' '}
          <strong className="font-bold text-white" data-id="element-185" data-mp="v0n1jyxut6nn">DVO Clinical Workflow Builder™</strong> to help
          you do.
        </p>

        <div className="mx-auto mt-9 max-w-md" data-id="element-186" data-mp="7bvhjuuf3uly">
          <CTAButton label="Get the DVO Clinical Workflow Builder™" subline="$27 one-time · Instant access · Lifetime access · 7-day guarantee" data-id="element-187" data-mp="2bg658tp4x6m" />
        </div>

        <div className="mt-9" data-id="element-188" data-mp="baurxuyx4jks">
          <Countdown label="This price expires in" variant="dark" data-id="element-189" data-mp="b9t74ys3oipv" />
        </div>
      </div>
    </section>;
}